<template>
  <div class="modal_card">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>{{ modalInfo.header }}</h1>
      <form @submit.prevent="submitUser">
        <b-field
          label="Имя:"
          type="is-info"
          class="left_input has_icon"
          :message="errors.first('name')"
          :class="errors.first('name') ? 'error' : ''"
        >
          <b-input
            placeholder="Имя"
            v-model="userInfo.name"
            name="name"
            icon="mdi mdi-account"
            v-validate="{ required: true, min: 2, max: 20 }"
          ></b-input>
        </b-field>
        <b-field
          label="Фамилия:"
          type="is-info"
          class="right_input has_icon"
          :message="errors.first('surname')"
          :class="errors.first('surname') ? 'error' : ''"
        >
          <b-input
            placeholder="Фамилия"
            v-model="userInfo.surname"
            name="surname"
            icon="mdi mdi-account"
            v-validate="{ required: true, min: 2, max: 20 }"
          ></b-input>
        </b-field>
        <b-field
          label="Отчество:"
          type="is-info"
          class="left_input has_icon"
          :message="errors.first('patronymic')"
          :class="errors.first('patronymic') ? 'error' : ''"
        >
          <b-input
            placeholder="Отчество"
            v-model="userInfo.patronymic"
            name="patronymic"
            icon="mdi mdi-account"
            v-validate="{ max: 20 }"
          ></b-input>
        </b-field>
        <b-field label="Должность:" type="is-info" class="right_input has_icon">
          <b-input placeholder="Должность" icon="mdi mdi-account-tie" v-model="userInfo.position"></b-input>
        </b-field>
        <button class="add_user_button modal_button left_button">{{ modalInfo.button }}</button>
        <button @click="$emit('close-modal')" class="close_button modal_button right_button">Отмена</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modalInfo: {
      default: () => {},
      type: Object
    },
    userInfo: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      isLoading: false,
      isOpen: true,
      dict: {
        custom: {
          name: {
            required: 'Поле не заполнено',
            min: 'Слишком короткое имя',
            max: 'Слишком длинное имя'
          },
          surname: {
            required: 'Поле не заполнено',
            min: 'Слишком короткая фамилия',
            max: 'Слишком длинная фамилия'
          },
          patronymic: {
            max: 'Слишком длинное значение'
          },
          email: {
            required: 'Поле не заполнено',
            email: 'Неверный формат',
            regex: 'Логин должен состоять из латинских букв'
          }
        }
      }
    }
  },
  methods: {
    submitUser() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit(this.modalInfo.action)
        }
      })
    },
  },
  created() {
    this.$validator.localize('ru', this.dict)
  },
}
</script>
